import { jsx, jsxs } from 'react/jsx-runtime';
import { isNil } from '@flex-design-system/fx-utils/common';
import { styled } from '@flex-design-system/stitches-react';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import '../../utils/styles/flex.mjs';
import Stack from '../../utils/styles/stack.mjs';
import { SlotRoot } from '../utility/layout.mjs';
import BackButton from './BackButton.mjs';
import { SLOT_GAP } from './constants.mjs';
import { TitleProvider } from './context.mjs';
import { title } from './title.vanilla.mjs';

const TitleImpl = forwardRef(
  ({
    className: classNameFromProps,
    size = "default",
    children,
    leftSlot,
    rightSlot,
    ...props
  }, ref) => {
    return /* @__PURE__ */ jsx(TitleProvider, { size, children: /* @__PURE__ */ jsx(
      StyledDiv,
      {
        className: classNames(title({ size }), classNameFromProps),
        ...props,
        ref,
        asChild: true,
        children: /* @__PURE__ */ jsxs(Stack.Horizontal, { space: SLOT_GAP, children: [
          !isNil(leftSlot) && /* @__PURE__ */ jsx(SlotRoot, { children: leftSlot }),
          children,
          !isNil(rightSlot) && /* @__PURE__ */ jsx(SlotRoot, { children: rightSlot })
        ] })
      }
    ) });
  }
);
const StyledDiv = styled(Primitive.div);
const Title = Object.assign({}, styled(TitleImpl), {
  BackButton: styled(BackButton)
});

export { Title as default };
//# sourceMappingURL=Title.mjs.map
